'use strict';
import * as $j_app$002edata$002e$002dApp$002dDocument$002dOrganization$002dInfo$002dForm from "./app.data.-App-Document-Organization-Info-Form.js";
import * as $j_app$002edata$002e$002dOrganization$002dAddress$0024package$0024$002dOrganization$002dAddress$002dForm$0024 from "./app.data.-Organization-Address$package$-Organization-Address-Form$.js";
import * as $j_app$002edata$002e$002dOrganization$002dName$0024package$0024$002dOrganization$002dName$002dForm$0024 from "./app.data.-Organization-Name$package$-Organization-Name-Form$.js";
import * as $j_app$002edata$002edata$005fpoint$005ftypes$0024package$0024$002dCertificate$002dOf$002dOrigin$002dAuthority$002dForm$0024 from "./app.data.data_point_types$package$-Certificate-Of-Origin-Authority-Form$.js";
import * as $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6 from "./internal-3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.js";
import * as $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c from "./internal-9eb04c7a932b923c3bc5eb25fd6219ee930b689c.js";
var $p;
/** @constructor */
function $c_Lapp_data_AppDocumentOrganizationInfoForm$$anon$4() {
}
export { $c_Lapp_data_AppDocumentOrganizationInfoForm$$anon$4 as $c_Lapp_data_AppDocumentOrganizationInfoForm$$anon$4 };
$p = $c_Lapp_data_AppDocumentOrganizationInfoForm$$anon$4.prototype = new $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$h_O();
$p.constructor = $c_Lapp_data_AppDocumentOrganizationInfoForm$$anon$4;
/** @constructor */
function $h_Lapp_data_AppDocumentOrganizationInfoForm$$anon$4() {
}
export { $h_Lapp_data_AppDocumentOrganizationInfoForm$$anon$4 as $h_Lapp_data_AppDocumentOrganizationInfoForm$$anon$4 };
$h_Lapp_data_AppDocumentOrganizationInfoForm$$anon$4.prototype = $p;
$p.bYA = (function(src) {
  var $x_3 = $j_app$002edata$002e$002dOrganization$002dName$0024package$0024$002dOrganization$002dName$002dForm$0024.$m_Lapp_data_OrganizationName$package$OrganizationNameForm$().aG().ak(src.pI);
  var $x_2 = $j_app$002edata$002e$002dOrganization$002dAddress$0024package$0024$002dOrganization$002dAddress$002dForm$0024.$m_Lapp_data_OrganizationAddress$package$OrganizationAddressForm$().aG().ak(src.rZ);
  var this$1 = src.Ly;
  if (this$1.c()) {
    var $x_1 = $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$m_s_None$();
  } else {
    var arg1 = this$1.g();
    var $x_1 = $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$m_s_Option$().as($j_app$002edata$002edata$005fpoint$005ftypes$0024package$0024$002dCertificate$002dOf$002dOrigin$002dAuthority$002dForm$0024.$m_Lapp_data_data\uff3fpoint\uff3ftypes$package$CertificateOfOriginAuthorityForm$().aG().ak(arg1));
  }
  return new $j_app$002edata$002e$002dApp$002dDocument$002dOrganization$002dInfo$002dForm.$c_Lapp_data_AppDocumentOrganizationInfoForm($x_3, $x_2, $x_1);
});
$p.ak = (function(src) {
  return this.bYA(src);
});
var $d_Lapp_data_AppDocumentOrganizationInfoForm$$anon$4 = new $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$TypeData().i($c_Lapp_data_AppDocumentOrganizationInfoForm$$anon$4, "app.data.AppDocumentOrganizationInfoForm$$anon$4", ({
  Cq: 1,
  V: 1,
  U: 1
}));
export { $d_Lapp_data_AppDocumentOrganizationInfoForm$$anon$4 as $d_Lapp_data_AppDocumentOrganizationInfoForm$$anon$4 };
//# sourceMappingURL=app.data.-App-Document-Organization-Info-Form$$anon$4.js.map
